"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IMAGE_FORMATS = exports.VIDEO_FORMATS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _color = _interopRequireDefault(require("color"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _DeleteButton = _interopRequireDefault(require("../button/DeleteButton"));

var _ViewButton = _interopRequireDefault(require("../button/ViewButton"));

var _LoadingIndicator = _interopRequireDefault(require("../effect/LoadingIndicator"));

var _styling = require("../../toolkit/styling");

var _image = require("../../toolkit/image");

var _fs = require("../../toolkit/fs");

var _providers = require("../../toolkit/providers");

var _dimen = require("../../toolkit/dimen");

var _localization = require("../../toolkit/localization");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/icon-file.svg' */

/* SVGs */
var fileIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgyNHYyNEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBmaWxsPSIjQjcxRDFEIiBmaWxsLW9wYWNpdHk9IjAiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0iIzRBNUY2RSIgZD0iTTcgMTFIMTd2Mkg3di0yeiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";

/* babel-plugin-inline-import '../../img/darkink-upload.svg' */
var uploadIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTkuMDAxIDMuNTE3VjEyYTEgMSAwIDAgMS0xIDFIOGExIDEgMCAwIDEtMS0xVjMuNTE2TDIuNzk1IDcuNjk0YTEuMDU2IDEuMDU2IDAgMCAxLTEuNDg3IDAgMS4wNCAxLjA0IDAgMCAxIDAtMS40NzdMNy4yNTcuMzA2YTEuMDU2IDEuMDU2IDAgMCAxIDEuNDg2IDBsNS45NSA1LjkxYTEuMDQgMS4wNCAwIDAgMS0uMDAyIDEuNDc4IDEuMDU2IDEuMDU2IDAgMCAxLTEuNDg2IDBMOS4wMDEgMy41MTd6TTE0IDE0LjAxdi0xYzAtLjU1NC40NDctMS4wMDkgMS0xLjAwOS41NTMgMCAxIC40NTUgMSAxLjAwOFYxNkgwdi0yLjk5MkMwIDEyLjQ1NS40NDggMTIgMSAxMmMuNTUzIDAgMS4wMDEuNDU1IDEuMDAxIDEuMDA4djFIMTR6Ii8+CiAgICA8L2RlZnM+CiAgICA8dXNlIGZpbGw9IiM0QTVGNkUiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz4KPC9zdmc+Cg==";
var VIDEO_FORMATS = ["mp4", "mov", "wmv", "flv", "avi", "mkv", "webm"];
exports.VIDEO_FORMATS = VIDEO_FORMATS;
var IMAGE_FORMATS = ["png", "jpeg"];
exports.IMAGE_FORMATS = IMAGE_FORMATS;

var FileInput = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(FileInput, _Component);

  var _super = _createSuper(FileInput);

  function FileInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, FileInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "internalAttachments", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "pendingAttachments", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    _this.mounted = false;
    _this.dispose = null;
    (0, _initializerDefineProperty2["default"])(_this, "onDrop", _descriptor3, (0, _assertThisInitialized2["default"])(_this));

    _this.viewAttachment = function (index) {
      if (_this.props.onViewAttachments) {
        _this.props.onViewAttachments(_this.attachments, index);
      }
    };

    _this.onDropRejected = function () {
      var _this$props = _this.props,
          accepts = _this$props.accepts,
          maxSizeMB = _this$props.maxSizeMB;
      var toaster = new _providers.LegoToaster(_this.context);

      var _LocalizationStore = new _localization.LocalizationStore(_this.context),
          i18n = _LocalizationStore.i18n;

      var formats = accepts.replace(",", ", ").replace(".", "");
      toaster.negative(i18n("File is not valid. Please upload a {%1=file extension} file less than {%2= max file size in megabytes}MB", formats, maxSizeMB));
    };

    _this.renderSurface = function (_ref) {
      var isDragActive = _ref.isDragActive;

      var _LocalizationStore2 = new _localization.LocalizationStore(_this.context),
          i18n = _LocalizationStore2.i18n;

      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          _this$props2$prompt = _this$props2.prompt,
          prompt = _this$props2$prompt === void 0 ? i18n("Drop a file here to upload") : _this$props2$prompt;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          opacity: isDragActive ? 0.3 : 1
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.titleContainer)
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(_this.styles.title)
      }, prompt), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: {
          marginTop: 15
        },
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.button)
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: (0, _styling.css)(_this.styles.uploadIcon),
        src: uploadIcon,
        draggable: false,
        alt: "upload icon"
      }), /*#__PURE__*/_react["default"].createElement("section", null, "Select a file")))));
    };

    return _this;
  }

  (0, _createClass2["default"])(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "onAttachmentsChanged",
    value: function onAttachmentsChanged(attachments) {
      var onAttachmentsChanged = this.props.onAttachmentsChanged;
      this.internalAttachments = attachments;
      onAttachmentsChanged(attachments);
    }
  }, {
    key: "removeAttachment",
    value: function removeAttachment(attachment) {
      this.onAttachmentsChanged(this.attachments.filter(function (a) {
        return a.url !== attachment.url;
      }));
    }
  }, {
    key: "removePendingAttachment",
    value: function removePendingAttachment(pendingAttachment) {
      this.pendingAttachments = this.pendingAttachments.filter(function (a) {
        return a.id !== pendingAttachment.id;
      });
    }
  }, {
    key: "renderPendingAttachment",
    value: function renderPendingAttachment(attachment) {
      var _this2 = this;

      var hideFilename = this.props.hideFilename;

      var _LocalizationStore3 = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore3.i18n;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.preview, this.styles.previewAnim),
        key: "pending_attachment_".concat(attachment.fileName)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.previewImageContainer)
      }, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
        type: "spinner"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.previewImageOverlay)
      }, /*#__PURE__*/_react["default"].createElement(_DeleteButton["default"], {
        popoverContent: i18n("Remove"),
        onClick: function onClick() {
          return _this2.removePendingAttachment(attachment);
        }
      }))), !hideFilename && /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.previewFilename)
      }, attachment.fileName));
    }
  }, {
    key: "getFormat",
    value: function getFormat(attachment) {
      if (attachment.ext != null) {
        return attachment.ext.substring(1).toLowerCase();
      }

      try {
        var url = new URL(attachment.url.toLowerCase());
        var chunks = url.pathname.split(".");

        if (chunks.length > 1) {
          return chunks[chunks.length - 1];
        }
      } catch (_unused) {
        return undefined;
      }
    }
  }, {
    key: "isImage",
    value: function isImage(ext) {
      return [".jpeg", ".jpg", ".png", ".webp", ".gif"].includes(ext.toLowerCase());
    }
  }, {
    key: "renderAttachmentMedia",
    value: function renderAttachmentMedia(attachment) {
      var isVideo = this.isVideo;

      var _LocalizationStore4 = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore4.i18n;

      if (attachment.isImage) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: attachment.url,
          draggable: false,
          alt: attachment.fileName,
          className: (0, _styling.css)(this.styles.previewImage)
        });
      }

      if (isVideo) {
        return /*#__PURE__*/_react["default"].createElement("video", {
          autoPlay: true,
          loop: true,
          muted: true,
          height: "100%"
        }, /*#__PURE__*/_react["default"].createElement("source", {
          src: attachment.url
        }), i18n("Your browser does not support videos"));
      }

      return /*#__PURE__*/_react["default"].createElement("img", {
        src: fileIcon,
        draggable: false,
        alt: "file icon"
      });
    }
  }, {
    key: "renderAttachment",
    value: function renderAttachment(attachment, index) {
      var _this3 = this;

      var isVideo = this.isVideo;
      var _this$props3 = this.props,
          onViewAttachments = _this$props3.onViewAttachments,
          hideFilename = _this$props3.hideFilename;

      var _LocalizationStore5 = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore5.i18n;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.preview),
        key: "attachment_".concat(attachment.url)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(isVideo ? this.styles.previewVideoContainer : this.styles.previewImageContainer)
      }, this.renderAttachmentMedia(attachment), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.previewImageOverlay)
      }, /*#__PURE__*/_react["default"].createElement(_DeleteButton["default"], {
        popoverContent: i18n("Remove"),
        onClick: function onClick() {
          return _this3.removeAttachment(attachment);
        }
      }), onViewAttachments && /*#__PURE__*/_react["default"].createElement(_ViewButton["default"], {
        className: (0, _styling.css)(this.styles.viewButton),
        onClick: function onClick() {
          return _this3.viewAttachment(index);
        }
      }))), !hideFilename && /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.previewFilename)
      }, attachment.fileName));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _LocalizationStore6 = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore6.i18n;

      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          accepts = _this$props4.accepts,
          maxSizeMB = _this$props4.maxSizeMB,
          className = _this$props4.className,
          _this$props4$attachme = _this$props4.attachmentListLabel,
          attachmentListLabel = _this$props4$attachme === void 0 ? i18n("Attachments") : _this$props4$attachme;
      var showAttachments = this.fileCount > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        accept: accepts,
        disabled: disabled,
        onDropRejected: this.onDropRejected,
        onDropAccepted: this.onDrop,
        maxSize: maxSizeMB * 1048576,
        multiple: this.fileCount < this.maxAttachments - 1,
        className: (0, _styling.css)(this.styles.surface)
      }, this.renderSurface), showAttachments && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.attachments)
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.attachmentsTitle)
      }, attachmentListLabel), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.previews)
      }, this.attachments.map(function (a, i) {
        return _this4.renderAttachment(a, i);
      }), this.pendingAttachments.map(function (a) {
        return _this4.renderPendingAttachment(a);
      }))));
    }
  }, {
    key: "maxAttachments",
    get: function get() {
      var maxAttachments = this.props.maxAttachments;
      return maxAttachments || 1;
    }
  }, {
    key: "fileCount",
    get: function get() {
      return this.pendingAttachments.length + this.attachments.length;
    }
  }, {
    key: "attachments",
    get: function get() {
      var internalAttachments = this.internalAttachments,
          attachments = this.props.attachments;

      if (attachments != null) {
        return attachments;
      }

      return internalAttachments;
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props5 = this.props,
          disabled = _this$props5.disabled,
          backgroundColor = _this$props5.backgroundColor;

      var dimenStore = _dimen.DimenStore.instance();

      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          corePrimary = _this$context$theming2.corePrimary,
          pageBackground = _this$context$theming2.pageBackground,
          textDark = _this$context$theming2.textDark,
          textLight = _this$context$theming2.textLight,
          textBlack = _this$context$theming2.textBlack,
          borderPrimaryDark = _this$context$theming2.borderPrimaryDark,
          surfaceLight = _this$context$theming2.surfaceLight,
          fonts = _this$context$theming.fonts;
      var attachmentKeyframes = {
        from: {
          transform: "scale(0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale(1, 1)",
          opacity: 1
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          opacity: disabled ? 0.6 : 1,
          display: "flex",
          flexDirection: "column",
          position: "relative"
        },
        surface: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          padding: "22px 20px",
          borderRadius: 4,
          flex: 1,
          transition: "opacity 0.3s linear",
          backgroundColor: backgroundColor || pageBackground,
          border: "solid 1px ".concat(borderPrimaryDark),
          marginBottom: this.fileCount > 0 ? 160 : 0
        },
        titleContainer: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column"
        },
        title: {
          fontSize: 16,
          color: textDark,
          fontFamily: fonts.semibold,
          cursor: "default",
          userSelect: "none",
          textAlign: "center"
        },
        button: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        icon: {
          height: 16
        },
        attachments: {
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0
        },
        attachmentsTitle: {
          color: textBlack,
          lineHeight: 1.43,
          fontFamily: fonts.semibold,
          marginBottom: 3,
          cursor: "default"
        },
        previews: {
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          overflowX: "auto",
          overflowY: "hidden"
        },
        preview: {
          display: "flex",
          flexDirection: "column",
          ":not(:last-child)": {
            marginRight: 10
          },
          width: dimenStore.isSmallScreen ? 80 : 200
        },
        previewImageContainer: {
          border: "solid 1px ".concat(borderPrimaryDark),
          borderRadius: 4,
          marginBottom: 5,
          height: 95,
          backgroundColor: new _color["default"](surfaceLight).alpha(0.4).toString(),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative"
        },
        previewVideoContainer: {
          border: "solid 1px ".concat(borderPrimaryDark),
          borderRadius: 4,
          marginBottom: 5,
          height: 95,
          backgroundColor: "black",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative"
        },
        previewImageOverlay: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          backgroundColor: new _color["default"](corePrimary).alpha(0.28).toString(),
          padding: 8,
          opacity: 0,
          transition: "opacity 250ms",
          ":hover": {
            opacity: 1
          }
        },
        viewButton: {
          marginLeft: 8
        },
        previewImage: {
          maxHeight: "100%",
          maxWidth: "100%",
          borderRadius: 2
        },
        previewFilename: {
          color: textLight,
          fontFamily: fonts.semibold,
          marginTop: 5,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          cursor: "default"
        },
        uploadIcon: {
          height: 12,
          marginRight: 7
        },
        previewAnim: {
          animationName: [attachmentKeyframes],
          animationDuration: "200ms"
        }
      });
    }
  }, {
    key: "isVideo",
    get: function get() {
      var accepts = this.props.accepts;
      return accepts.split(",").every(function (ext) {
        return VIDEO_FORMATS.includes(ext.substring(1).toLowerCase());
      });
    }
  }]);
  return FileInput;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  accepts: {
    required: true,
    type: "string",
    description: "Comma-separated list of file extensions that are acceptable"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "disabled the input if set to `true`.\n      Set when submitting to api to prevent the user from modifying"
  },
  maxSizeMB: {
    required: true,
    type: "number",
    description: "Maximum size of the attachment (in MB)"
  },
  minDimensions: {
    required: false,
    type: "[number, number]",
    description: "Minimum width and height of the attachment. Applicable to images only"
  },
  maxAttachments: {
    type: "number",
    required: false,
    defaultValue: "1",
    description: "maximum number of attachments that are allowed"
  },
  attachments: {
    type: "?ReadonlyArray<AttachmentInfo>",
    required: false,
    defaultValue: "null",
    description: "the current list of attachments"
  },
  onAttachmentsChanged: {
    type: "(attachments: ReadonlyArray<AttachmentInfo>) => mixed",
    required: true,
    description: "called when the list of attachments changes " + "(an item as added or deleted).\n      Param is the latest list of attachment."
  },
  onViewAttachments: {
    type: "(attachments: ReadonlyArray<AttachmentInfo>, viewIndex: number) => mixed",
    required: false,
    defaultValue: "null",
    description: "If this function is specified, there will be a \"view\" button for" + " each attachment. And when the button is clicked, this function" + " is called."
  },
  hideFilename: {
    type: "boolean",
    required: false,
    defaultValue: "false",
    description: "Don't show the filename of the attachments"
  },
  bucket: {
    type: "InsecureS3Bucket",
    required: true,
    description: "The S3 bucket that the file should be uploaded to."
  },
  prompt: {
    type: "string",
    required: false,
    defaultValue: "Drop a file here to upload",
    description: "Prompt displayed above select file button."
  },
  attachmentListLabel: {
    type: "string",
    required: false,
    defaultValue: "Attachments",
    description: "Label that goes on top of the list of uploaded attachments"
  },
  onUpload: {
    type: "(file: File, options: FileUploadOptions) => Promise<FileUploadResponse | undefined>",
    required: true,
    description: "Callback to perform the file upload and return a url where the file can be downloaded"
  }
}, _class3.demoProps = [{
  demoDescription: "active",
  accepts: ".jpeg,.png,.pdf",
  onAttachmentsChanged: function onAttachmentsChanged() {},
  maxSizeMB: 5,
  maxAttachments: 2,
  bucket: "TEMP_UPLOADS",
  onUpload: function () {
    var _onUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", undefined);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function onUpload() {
      return _onUpload.apply(this, arguments);
    }

    return onUpload;
  }()
}, {
  demoDescription: "disabled",
  disabled: true,
  accepts: ".jpeg,.png,.pdf",
  onAttachmentsChanged: function onAttachmentsChanged() {},
  maxSizeMB: 5,
  maxAttachments: 2,
  bucket: "TEMP_UPLOADS",
  onUpload: function () {
    var _onUpload2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", undefined);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function onUpload() {
      return _onUpload2.apply(this, arguments);
    }

    return onUpload;
  }()
}], _class3.discussion = "\n    This component is largly built on [react-dropzone](https://react-dropzone.netlify.com/#proptypes)\n  ", _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "internalAttachments", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "pendingAttachments", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "maxAttachments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxAttachments"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "fileCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "fileCount"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "attachments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "attachments"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onAttachmentsChanged", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "onAttachmentsChanged"), _class2.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onDrop", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(acceptedFiles) {
        var maxAttachments, _this5$props, minDimensions, onUpload, bucket, toaster, _LocalizationStore7, i18n, totalNumFiles, _iterator, _step, _loop, _ret;

        return _regenerator["default"].wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                maxAttachments = _this5.maxAttachments;
                _this5$props = _this5.props, minDimensions = _this5$props.minDimensions, onUpload = _this5$props.onUpload, bucket = _this5$props.bucket;
                toaster = new _providers.LegoToaster(_this5.context);
                _LocalizationStore7 = new _localization.LocalizationStore(_this5.context), i18n = _LocalizationStore7.i18n;
                totalNumFiles = _this5.fileCount + acceptedFiles.length;

                if (!(totalNumFiles > maxAttachments)) {
                  _context4.next = 8;
                  break;
                }

                toaster.negative(i18n("Too many files attached. Maximum is {%1=max number of attachments}", maxAttachments));
                return _context4.abrupt("return");

              case 8:
                _iterator = _createForOfIteratorHelper(acceptedFiles);
                _context4.prev = 9;
                _loop = /*#__PURE__*/_regenerator["default"].mark(function _loop() {
                  var _file$name$split$pop;

                  var file, ext, isImage, imageWidth, imageHeight, _yield$getImageSize, _yield$getImageSize2, _minDimensions, minImageWidth, minImageHeight, pendingAttachment, data, response, downloadUrl, stillWantAttachment;

                  return _regenerator["default"].wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          file = _step.value;
                          ext = (_file$name$split$pop = file.name.split(".").pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase();

                          if (!(ext == null)) {
                            _context3.next = 4;
                            break;
                          }

                          return _context3.abrupt("return", {
                            v: void 0
                          });

                        case 4:
                          isImage = _this5.isImage(".".concat(ext));
                          imageWidth = null;
                          imageHeight = null;

                          if (!isImage) {
                            _context3.next = 19;
                            break;
                          }

                          _context3.next = 10;
                          return (0, _image.getImageSize)(file);

                        case 10:
                          _yield$getImageSize = _context3.sent;
                          _yield$getImageSize2 = (0, _slicedToArray2["default"])(_yield$getImageSize, 2);
                          imageWidth = _yield$getImageSize2[0];
                          imageHeight = _yield$getImageSize2[1];

                          if (!minDimensions) {
                            _context3.next = 19;
                            break;
                          }

                          _minDimensions = (0, _slicedToArray2["default"])(minDimensions, 2), minImageWidth = _minDimensions[0], minImageHeight = _minDimensions[1];

                          if (!(imageWidth < minImageWidth || imageHeight < minImageHeight)) {
                            _context3.next = 19;
                            break;
                          }

                          toaster.negative(i18n("Image resolution too low. Minimum is {%1=min image width}x{%2=min image height}", minImageWidth, minImageHeight));
                          return _context3.abrupt("return", {
                            v: void 0
                          });

                        case 19:
                          pendingAttachment = {
                            ext: ext,
                            isImage: isImage,
                            id: new Date().getTime(),
                            fileName: file.name
                          };
                          _this5.pendingAttachments = [].concat((0, _toConsumableArray2["default"])(_this5.pendingAttachments), [pendingAttachment]);
                          _context3.next = 23;
                          return (0, _fs.readFile)(file);

                        case 23:
                          data = _context3.sent;

                          if (!(data == null)) {
                            _context3.next = 27;
                            break;
                          }

                          toaster.negative(i18n("Could not read the file you uploaded"));
                          return _context3.abrupt("return", {
                            v: void 0
                          });

                        case 27:
                          _context3.next = 29;
                          return onUpload(file, {
                            bucket: bucket,
                            filename: file.name,
                            contentType: file.type
                          });

                        case 29:
                          response = _context3.sent;
                          downloadUrl = response === null || response === void 0 ? void 0 : response.downloadUrl;

                          if (!(downloadUrl == null)) {
                            _context3.next = 34;
                            break;
                          }

                          _this5.removePendingAttachment(pendingAttachment);

                          return _context3.abrupt("return", {
                            v: void 0
                          });

                        case 34:
                          stillWantAttachment = _this5.pendingAttachments.some(function (pa) {
                            return pa.id === pendingAttachment.id;
                          });

                          if (stillWantAttachment) {
                            _context3.next = 37;
                            break;
                          }

                          return _context3.abrupt("return", {
                            v: void 0
                          });

                        case 37:
                          (0, _mobx.runInAction)(function () {
                            _this5.onAttachmentsChanged([].concat((0, _toConsumableArray2["default"])(_this5.attachments), [_objectSpread(_objectSpread({
                              ext: ext,
                              isImage: isImage,
                              url: downloadUrl || "",
                              fileName: file.name,
                              file: file,
                              serverParams: {
                                url: downloadUrl || "",
                                original_filename: file.name
                              }
                            }, imageWidth != null ? {
                              imageWidth: imageWidth
                            } : {}), imageHeight != null ? {
                              imageHeight: imageHeight
                            } : {})]));

                            _this5.removePendingAttachment(pendingAttachment);
                          });

                        case 38:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _loop);
                });

                _iterator.s();

              case 12:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 19;
                  break;
                }

                return _context4.delegateYield(_loop(), "t0", 14);

              case 14:
                _ret = _context4.t0;

                if (!((0, _typeof2["default"])(_ret) === "object")) {
                  _context4.next = 17;
                  break;
                }

                return _context4.abrupt("return", _ret.v);

              case 17:
                _context4.next = 12;
                break;

              case 19:
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t1 = _context4["catch"](9);

                _iterator.e(_context4.t1);

              case 24:
                _context4.prev = 24;

                _iterator.f();

                return _context4.finish(24);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, null, [[9, 21, 24, 27]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "removeAttachment", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeAttachment"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "removePendingAttachment", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "removePendingAttachment"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isVideo"), _class2.prototype)), _class2)) || _class;

var _default = FileInput;
exports["default"] = _default;